import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

import { SIDE_NAV_DRAWER_WIDTH } from 'components/common/side-nav/settings'

// `open` drives the content offset and must not reach the DOM as an attribute.
const SideNavLayout = styled(Box, { shouldForwardProp: prop => prop !== 'open' })<{ open?: boolean }>(({ theme, open }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: 0,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: `${SIDE_NAV_DRAWER_WIDTH}px`,
    [theme.breakpoints.down('lg')]: {
      marginLeft: 0,
    },
  }),
}))

export default SideNavLayout
